import create from 'zustand'

export const appStore = create(set => ({
    isFileUploaded: false,
    transactions: [],
    seIisFileUploaded: (isFileUploaded) => set({ isFileUploaded }),
    setTransactions: (transactions) => set({ transactions }),
}))